module.exports = __webpack_public_path__ + "static/logo-mobile-a88af0947f0df06f0649984a1653ef03.png";